export const ALLOCATION_STEP_LABELS: Record<string, string> = {
  FETCH_ALLOCATION_CASES: 'Fetching cases to allocate',
  DELAY_FOR_BUILD_AND_SAVE: 'Checking capacity for agents',
  ALLOCATE_USING_CAPACITY: 'Identifying flows to allocate',
  VALIDATE_AND_GENERATE_ALTERNATE_FLOWS: 'Triggering region based mapping',
  TRIGGER_ALT_ALLOCATIONS: 'Checking for Region based response',
  CHECK_AND_STORE_ALT_ALLOCATIONS_POLLER: 'Allocate Cases to agents',
  DETERMINE_FINAL_FLOW_AND_ALLOCATE: 'Triggering notifications for agents',
  DELAY_FOR_FINAL_ALLOCATIONS: 'Finalizing allocations',
  TRIGGER_ALLOCATIONS_NOTIFICATIONS: 'Triggering notifications for agents'
};

export const getStepLabel = (stepName: string): string => {
  return ALLOCATION_STEP_LABELS[stepName] || stepName;
};

export enum CompletionStatus {
  NEEDS_REUPLOAD = 'SOME_NON_FINAL_RUNS_COMPLETED',
  IN_PROGRESS_NON_FINAL = 'SOME_NON_FINAL_RUN_IN_PROGRESS',
  IN_PROGRESS_FINAL = 'FINAL_RUN_IN_PROGRESS',
  COMPLETED = 'ALL_RUNS_COMPLETED_FOR_TODAY'
}
export interface AllocationStatusDisplayProps {
  completionStatus?: string;
  onReupload: () => void;
}

export const STATUS_MESSAGES = {
  NEEDS_REUPLOAD: 'Ameyo upload already completed and needs to be re-uploaded',
  IN_PROGRESS: 'Might take up to 30 min'
};

export enum CollectionType {
  TELE = 'TELE',
  FIELD = 'FIELD'
}

export enum AllocationTriggerType {
  ACTUAL = 'ACTUAL',
  MOCK = 'MOCK'
}

export enum AllocationStatus {
  IN_PROGRESS = 'INPROGRESS',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED'
}

export enum FAILURE_REASON {
  CAPACITY_BREACH = 'Capacity Breach',
  INFEASIBLE_LPP_RESULTS = 'Infeasible LPP Results'
}
